import { Dropdown } from '@silverfort/sf-components';

import Label from '../Controls/Label/Label';
import { LOGIN_HINT_OPTIONS } from './consts';
import styles from './SSOApps.module.css';
import { SettingsFeatureLock } from '../LockedFeatures/SettingsFeatureLock';
import { SUBCATEGORIES } from '../../common/categories';

const { SSO_APPS } = SUBCATEGORIES;

const LoginHint = ({ field, changedFunc, disabled }) => {
    return (
        <div className={styles.textInput}>
            <Label value={field.name} />
            <SettingsFeatureLock id={SSO_APPS.ID} isTabId={true}>
                <Dropdown
                    className="w-full px-[8px] py-[4px] mx-[0] my-[4px] inline-block border-[1px] border-[solid] border-[#ccc] rounded text-[14px] font-thin outline-[none] min-w-[70px] font-['OpenSans',_sans-serif] leading-[20px] h-[auto] [&]:bg-[#e5ebf1] [&]:hover:bg-[#e5ebf1]"
                    items={LOGIN_HINT_OPTIONS}
                    variant="trigger"
                    onChange={(newValue) => {
                        changedFunc(field.id, newValue);
                    }}
                    disabled={disabled}
                    menuClassName="w-[350px]"
                    selectedItems={[field.value]}
                />
            </SettingsFeatureLock>
        </div>
    );
};

export default LoginHint;
